exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content[data-v-1f192fc6] P {\r\n  padding-left: 1em;\r\n  color: #ffffff;\r\n  text-indent: -1em;\n}\r\n", ""]);

// exports
